module.exports = __webpack_public_path__ + "img/product_category_preview_image-4.d089ae4.webp";